import React from "react";
import Loader from "../Loader";
import * as styles from "./styles.module.scss";
const Fallback = () => {
    return (React.createElement("div", { className: styles.loader },
        React.createElement(Loader, { size: 100 })));
};
export default Fallback;
